// Logo IAvocat.ai — aligné avec l'identité visuelle de la landing.
// Le mark est un carré bordeaux #6B1F2A avec une équerre claire (#F1EEE6).
// Le wordmark utilise Inter (titre) + Spectral italique pour le ".ai".

const BRAND = '#6B1F2A'
const MARK_INNER = '#F1EEE6'

export function IAvocatMark({ size = 28, radius, style }) {
  const r = radius ?? Math.round(size * 7 / 32)
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, display: 'block', ...style }}
      aria-hidden="true"
    >
      <rect width="32" height="32" rx={r} fill={BRAND} />
      <path
        d="M7 25 V8 a1 1 0 0 1 1 -1 H25"
        stroke={MARK_INNER}
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  )
}

// Wordmark complet (mark + texte "IAvocat.ai").
// `tone` :
//   - 'auto' (défaut) : suit le thème courant via CSS variables
//   - 'dark' : force ink foncé (à utiliser sur fond clair fixe)
//   - 'light' : force ivoire clair (à utiliser sur fond sombre fixe — ex.
//     panneau ink du onboarding)
export default function IAvocatLogo({
  size = 28,
  showWordmark = true,
  tone = 'auto',
  fontSize,
  letterSpacing = '-0.01em',
  gap = 10,
  style,
}) {
  const inkColor = tone === 'light'
    ? '#F1EEE6'
    : tone === 'dark'
      ? '#0E1410'
      : 'var(--text-primary)'
  const mutedColor = tone === 'light'
    ? 'rgba(241,238,230,0.55)'
    : tone === 'dark'
      ? '#6F7570'
      : 'var(--text-muted)'
  const fs = fontSize ?? Math.round(size * 0.56)

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap,
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        textDecoration: 'none',
        ...style,
      }}
    >
      <IAvocatMark size={size} />
      {showWordmark && (
        <span
          style={{
            fontSize: fs,
            fontWeight: 600,
            letterSpacing,
            color: inkColor,
            lineHeight: 1,
          }}
        >
          IAvocat<span style={{ color: mutedColor, fontWeight: 400 }}>.ai</span>
        </span>
      )}
    </span>
  )
}
